module.exports = __webpack_public_path__ + "img/lu.c77af8b0.svg";